export const BrandName = 'AWX';
export const PendoAPIKey = '';
